import { Component, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {

  constructor(private renderer: Renderer2) { }

  ngOnInit() {
    // Define the JavaScript code you want to inject
    const scriptCode = `!async function(){try{let e="6590e52d-71f1-4277-bfd9-3893fec7151b",w="qa-api.txtbox.in",a="https://qa-app.txtbox.in",o="",n="",c="",i=3e3,d="https://das-dev.deepalgorithms.io";async function t(){o=a+"/v1/conversive/button/run/"+e+"?latitude="+n+"&longitude="+c;let t=await fetch(o).then((t=>t.json())).then((t=>t)).catch((t=>{}));if("success"===t.response.status){let e=t.response;if(document.getElementById(e.data.button_config.scriptLocation))displayButton(e.data);else{const t=document.getElementsByTagName("head")[0],a=document.createElement("link"),o=document.createElement("script"),n=document.createElement("link"),c=document.createElement("script");a.rel="stylesheet",a.type="text/css",a.href=e.data.button_config.cssLocation,a.onload=()=>{t.appendChild(o)},t.appendChild(a),o.type="text/javascript",o.id=e.data.button_config.scriptLocation,o.src=e.data.button_config.scriptLocation,o.onload=()=>{displayButton(e.data)},n.rel="stylesheet",n.type="text/css",c.id=e.data.chatbot_config.chatbotCSS,n.href=e.data.chatbot_config.chatbotCSS,n.onload=()=>{t.appendChild(c)},t.appendChild(n),c.type="text/javascript",c.id=e.data.chatbot_config.chatbotJS,c.src=e.data.chatbot_config.chatbotJS,c.onload=()=>{loadChatBot(d,w,e.data)}}}}navigator.geolocation&&navigator.geolocation.getCurrentPosition((e=>{n=e.coords.latitude,c=e.coords.longitude,t()}),(e=>{t()}),{timeout:i}),setTimeout(t,i)}catch(s){}}();
    `;
    // Create a script element
    const scriptElement = this.renderer.createElement('script');
    scriptElement.type = 'text/javascript';
    scriptElement.text = scriptCode;

    // // Append the script element to the <head> section
    // this.renderer.appendChild(document.head, scriptElement);
  }

clearCookiesAndLocalStorage() {
  // Clear local storage
  localStorage.clear();

  // Clear cookies
  const cookies = document.cookie.split(";");
  for (let cookie of cookies) {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
      location.reload();

  }
}
}
